import React from "react";
import { cn } from "@/lib/utils";

const STYLES = {
  new: "bg-[hsl(210_25%_95%)] text-[hsl(206_53%_17%)] border-[hsl(206_24%_86%)]",
  contacted: "bg-[hsl(186_55%_92%)] text-[hsl(186_89%_22%)] border-[hsl(186_40%_80%)]",
  scheduled: "bg-[hsl(140_35%_92%)] text-[hsl(140_43%_28%)] border-[hsl(140_25%_80%)]",
  completed: "bg-[hsl(140_43%_43%)] text-white border-transparent",
  cancelled: "bg-[hsl(46_90%_92%)] text-[hsl(30_70%_25%)] border-[hsl(46_55%_80%)]",
  no_response: "bg-[hsl(8_55%_94%)] text-[hsl(8_55%_35%)] border-[hsl(8_35%_84%)]",
  sent: "bg-[hsl(140_35%_92%)] text-[hsl(140_43%_28%)] border-[hsl(140_25%_80%)]",
  pending: "bg-[hsl(46_90%_92%)] text-[hsl(30_70%_25%)] border-[hsl(46_55%_80%)]",
  failed: "bg-[hsl(8_55%_94%)] text-[hsl(8_55%_35%)] border-[hsl(8_35%_84%)]",
  active: "bg-[hsl(140_35%_92%)] text-[hsl(140_43%_28%)] border-[hsl(140_25%_80%)]",
  inactive: "bg-[hsl(210_18%_93%)] text-[hsl(195_10%_42%)] border-[hsl(206_24%_86%)]",
  invited: "bg-[hsl(186_55%_92%)] text-[hsl(186_89%_22%)] border-[hsl(186_40%_80%)]",
  supervisor: "bg-[hsl(206_47%_35%)] text-white border-transparent",
  admin: "bg-[hsl(210_25%_95%)] text-[hsl(206_53%_17%)] border-[hsl(206_24%_86%)]",
};

const LABELS = {
  new: "New",
  contacted: "Contacted",
  scheduled: "Scheduled",
  completed: "Completed",
  cancelled: "Cancelled",
  no_response: "No response",
  sent: "Sent",
  pending: "Pending",
  failed: "Failed",
  active: "Active",
  inactive: "Inactive",
  invited: "Invited",
  supervisor: "Supervisor",
  admin: "Admin",
};

export function StatusBadge({ status, label, className, ...props }) {
  return (
    <span className={cn("inline-flex items-center whitespace-nowrap rounded-full border px-2.5 py-0.5 text-xs font-semibold", STYLES[status] || STYLES.new, className)} data-status={status} {...props}>
      {label || LABELS[status] || status}
    </span>
  );
}

export const STATUS_LABELS = LABELS;
